import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface ISexDropDownProps {
    setSex?: (event) => void;
    sex: string | undefined;
    disabled: boolean;
    childMode: boolean;
}

interface ISexDropDownState {
    model: string[];
    loaded: boolean;
}

class SexDropDown extends Component<ISexDropDownProps & WithStyles<typeof styles>, ISexDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        let newModel: string[] = ['M','F'];

        this.setState({
            model: newModel,
            loaded: true,
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultAcademicYearVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item} value={item}>{item}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.childMode ? "Sex (this must be your child's legal sex)" : "Sex (this must be your legal sex)"}
                name="sex"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.sex}
                onChange={this.props.disabled ? undefined : this.props.setSex}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(SexDropDown);